import { NewQuotationPlan } from '../interfaces/plans';

export const ESSENTIAL_PLAN_OFFER_CODE = 'PlanEsencial';

export const PLANS_DEFAULT: NewQuotationPlan[] = [
  {
    id: 0,
    offerCode: ESSENTIAL_PLAN_OFFER_CODE,
    type: 'Plan',
    title: 'Esencial',
    price: 20,
    pricePEN: 76,
    isRecommended: false,
    isNewPlan: true,
    codeError: null,
  },
  {
    id: 1,
    offerCode: 'AETodoRiesgoRedPreferente',
    type: 'Todo',
    title: 'Riesgo Base',
    price: 31,
    pricePEN: 118,
    isRecommended: false,
    codeError: null,
  },
  {
    id: 2,
    offerCode: 'AETodoRiesgo1',
    type: 'Todo',
    title: 'Riesgo Full',
    price: 36,
    pricePEN: 137,
    isRecommended: true,
    codeError: null,
  },
];
